import { render } from "./VideosSection.vue?vue&type=template&id=6eb5e794&scoped=true"
import script from "./VideosSection.vue?vue&type=script&lang=js"
export * from "./VideosSection.vue?vue&type=script&lang=js"

import "./VideosSection.vue?vue&type=style&index=0&id=6eb5e794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb5e794"]])

export default __exports__